import React from 'react'
import clsx from 'clsx'
import iconsSet from './config'
import * as PropTypes from 'prop-types'

const CreatePartnerIcon = ({ name, className, size = 'm' }) => {
  const props = {}

  if (!iconsSet[name]) {
    return <span>NoIcon: {name}</span>
  }

  const Component = iconsSet[name][size]

  return <Component className={clsx('partner-logo', className)} {...props} />
}

CreatePartnerIcon.propTypes = {
  size: PropTypes.oneOf(['l', 'm', 's']),
  className: PropTypes.string,
  name: PropTypes.string,
}

const PartnerIcon = (args) => CreatePartnerIcon({ ...args })

export default PartnerIcon
